module.exports = __webpack_public_path__ + "97c28d6aaa13cf0f47d1f5e13dcdaceb.svg";